import { Component, Input, OnInit } from '@angular/core';
import {
  AccessoriesType,
  AvatarStyle,
  ClothType,
  EyebrowType,
  EyeType,
  FacialHairType,
  MouthType,
  SkinColor,
  TopType,
} from './types';
import { inputTypesMapping } from './input-types';

@Component({
  selector: 'ngx-get-avatar',
  templateUrl: './get-avatar.component.html',
})
export class GetAvatarComponent implements OnInit {
  @Input() avatarStyle: AvatarStyle = '';
  @Input() top: TopType = '';
  @Input() accessories: AccessoriesType = '';
  @Input() facialHair: FacialHairType = '';
  @Input() clothes: ClothType = '';
  @Input() eyes: EyeType = '';
  @Input() eyebrows: EyebrowType = '';
  @Input() mouth: MouthType = '';
  @Input() skin: SkinColor = '';

  @Input() width: string;
  @Input() height: string;

  @Input() random = false;

  constructor() {}

  ngOnInit(): void {
    if (this.random) {
      this.createRandomAvatar();
    }
  }

  getOptions() {
    return {
      avatarStyle: this.avatarStyle,
      top: this.top,
      accessories: this.accessories,
      facialHair: this.facialHair,
      clothes: this.clothes,
      eyes: this.eyes,
      eyebrows: this.eyebrows,
      mouth: this.mouth,
      skin: this.skin,
    };
  }

  private createRandomAvatar() {
    for (const [prop, opts] of Object.entries(inputTypesMapping)) {
      this[prop] = opts[Math.floor(Math.random() * opts.length)];
    }
  }
}
